module.exports = new __parcel__URL__("chemical.abdaeeec.jpg").toString();